<template>
  <div>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      title="导入修改波次"
      width="600px"
    >
      <div
        style="
          height: 50px;
          line-height: 30px;
          padding: 0 25px;
          display: flex;
          align-items: center;
        "
      >
        <el-button
          style="margin-right: 10px"
          size="small"
          type="danger"
          @click="downTemplate"
          >下载导入模板</el-button
        >
        <el-upload
          ref="upload"
          class="upload-demo"
          :action="action"
          :multiple="false"
          :limit="1"
          name="excel"
          :on-success="run"
          accept=""
          :auto-upload="false"
          :file-list="fileList"
          with-credentials
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <div slot="footer">
        <el-button type="" size="small" @click="toggle">关闭</el-button>
        <el-button type="primary" size="small" @click="doUpload">
          确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  data() {
    return {
      show: false,
      fileList: [],
      rs: {},
      action: `${apiBaseURL}/erp/WavePicking/importWavePickingShipping`,
    };
  },
  mounted() {
    this.fileList = [];
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    run(response) {
      if (response.code == 200) {
        this.$message.success("上传处理成功");
        this.fileList = [];
        window.open(apiBaseURL + response.data.file);
      } else {
        this.fileList = [];
        this.$message.error(response.msg);
      }
    },
    downTemplate() {
      this.$http
        .post("/erp/WavePicking/importWavePickingShipping", {
          download: 1,
        })
        .then((res) => {
          window.open(apiBaseURL + res.data.data.file);
        });
    },
    doUpload() {
      this.$refs.upload.submit();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/wavepicking/components/ExcelImport.vue